
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  position:relative;
  height:100%;
  container-type:inline-size;
}

.card-wrapper{
  --border-width:var(
    --sic-card--border-width,
    var(--sic-card--default--border-width)
  );
  --border-width--focus:6px;
  --border-radius--inner:var(--border-width);
  --anim-movement-amount:var(--spacing-03);

  background-color:var(--color-neutral-white);
  border-color:var(--sic-card--default--border-color);
  border-color:var(
    --sic-card--border-color,
    var(--sic-card--default--border-color)
  );
  border-width:var(--border-width);
  border-style:solid;
  border-radius:var(--sic-card--default--border-radius);
  border-radius:var(
    --sic-card--border-radius,
    var(--sic-card--default--border-radius)
  );
  height:100%;
  position:relative;
  z-index:1;
  cursor:pointer;
}

.card-wrapper a:focus-visible{
    outline:none !important;
  }

@media (prefers-reduced-motion: no-preference){

.card-wrapper{
    transition:all var(--duration-promptly) ease-in-out
}
  }

.card-image{
  display:block;
  overflow:hidden;
  position:relative;
}

@media (prefers-reduced-motion: no-preference){

.card-image > div,
  .card-image > picture{
      transition:all var(--duration-promptly) ease-in-out
  }
    }

.card-image > div img, .card-image > picture img{
      max-width:100%;
      width:100%;
      height:auto;
      aspect-ratio:auto;
    }

.card-image::after{
    background-color:var(--color-neutral-white);
    content:'';
    position:absolute;
    bottom:0;
    right:0;
    left:0;
    height:0;
  }

@media (prefers-reduced-motion: no-preference){

.card-image::after{
      transition:height var(--duration-promptly) ease-in-out
  }
    }

.card-icon{
  color:var(--sic-card--default--icon-color);
  color:var(--sic-card--icon-color, var(--sic-card--default--icon-color));
  display:block;
  padding:var(--sic-card--default--content-padding);
  padding:var(
    --sic-card--content-padding,
    var(--sic-card--default--content-padding)
  );
  padding-bottom:var(--spacing-02);
}

.card-icon sic-icon{
    --icon-size:var(
      --sic-card--icon-width,
      var(--sic-card--default--icon-width)
    );
    display:inline-block;
  }

.card-content{
  background-color:var(--color-neutral-white);
  border-radius:var(--sic-card--default--border-radius);
  border-radius:var(
    --sic-card--border-radius,
    var(--sic-card--default--border-radius)
  );
  color:var(--color-neutral-default);
  padding:var(--sic-card--default--content-padding);
  padding:var(
    --sic-card--content-padding,
    var(--sic-card--default--content-padding)
  );
}

@media (prefers-reduced-motion: no-preference){

.card-content{
    transition:all var(--duration-promptly) ease-in-out
}
  }

.eyebrow{
  font-size:var(--sic-card--default--eyebrow-font-size);
  font-size:var(
    --sic-card--eyebrow-font-size,
    var(--sic-card--default--eyebrow-font-size)
  );
  line-height:var(--sic-card--default--eyebrow-line-height);
  line-height:var(
    --sic-card--eyebrow-line-height,
    var(--sic-card--default--eyebrow-line-height)
  );
  margin-bottom:var(--spacing-02);
}

.heading{
  color:var(--sic-card--default--text-color);
  color:var(--sic-card--text-color, var(--sic-card--default--text-color));
  font-size:var(--sic-card--default--heading-font-size);
  font-size:var(
    --sic-card--heading-font-size,
    var(--sic-card--default--heading-font-size)
  );
  line-height:var(--sic-card--default--heading-line-height);
  line-height:var(
    --sic-card--heading-line-height,
    var(--sic-card--default--heading-line-height)
  );
}

.heading h2,
  .heading h3,
  .heading h4,
  .heading h5,
  .heading h6,
  .heading p,
  .heading div{
    font-size:var(--sic-card--default--heading-font-size);
    font-size:var(
      --sic-card--heading-font-size,
      var(--sic-card--default--heading-font-size)
    );
    font-weight:var(--fw-bold);
    line-height:var(--sic-card--default--heading-line-height);
    line-height:var(
      --sic-card--heading-line-height,
      var(--sic-card--default--heading-line-height)
    );
    margin:0;
  }

.description{
  --sic-text-color:var(--color-neutral-default);
  --sic-body-text--font-size:var(--body-01-font-size-mid);
  font-size:var(--body-01-font-size-mid);
  padding-top:var(--sic-card--default--text-padding-top);
  padding-top:var(
    --sic-card--text-padding-top,
    var(--sic-card--default--text-padding-top)
  );
}

.description p{
    margin-top:0;
    margin-bottom:0;
  }

.link-indicator{
  background-color:var(--color-primary-default);
  color:var(--color-neutral-white);
  fill:var(--color-neutral-white);
  position:absolute;
  overflow:hidden;
  clip:auto;
  width:var(--spacing-10);
  height:var(--spacing-10);
  word-wrap:normal;
  bottom:calc(-1 * var(--border-width));
  right:calc(-1 * var(--border-width));
  border-top-left-radius:var(--sic-card--default--border-radius);
  border-top-left-radius:var(
    --sic-card--border-radius,
    var(--sic-card--default--border-radius)
  );
  border-bottom-right-radius:var(--sic-card--default--border-radius);
  border-bottom-right-radius:var(
    --sic-card--border-radius,
    var(--sic-card--default--border-radius)
  );
  padding:var(--spacing-03);
  z-index:0;
}

.card-wrapper--with-image{
  border-color:transparent;
  border-width:var(--border-width);
  border-style:solid;
  background-color:var(--color-neutral-white);
}

.card-wrapper--with-image:hover .card-image > div,
      .card-wrapper--with-image:hover .card-image > picture,
      .card-wrapper--with-image:focus .card-image > div,
      .card-wrapper--with-image:focus .card-image > picture,
      .card-wrapper--with-image:focus-within .card-image > div,
      .card-wrapper--with-image:focus-within .card-image > picture,
      .card-wrapper--with-image:visited .card-image > div,
      .card-wrapper--with-image:visited .card-image > picture{
        transform:scale(1.1);
      }

.card-wrapper--with-image:hover .card-content .eyebrow,
      .card-wrapper--with-image:hover .card-content a > *,
      .card-wrapper--with-image:hover .card-content ::slotted(*),
      .card-wrapper--with-image:focus .card-content .eyebrow,
      .card-wrapper--with-image:focus .card-content a > *,
      .card-wrapper--with-image:focus .card-content ::slotted(*),
      .card-wrapper--with-image:focus-within .card-content .eyebrow,
      .card-wrapper--with-image:focus-within .card-content a > *,
      .card-wrapper--with-image:focus-within .card-content ::slotted(*),
      .card-wrapper--with-image:visited .card-content .eyebrow,
      .card-wrapper--with-image:visited .card-content a > *,
      .card-wrapper--with-image:visited .card-content ::slotted(*){
        transform:translateY(calc(var(--spacing-02) * -1));
      }

.card-wrapper--with-image:hover .card-content::before, .card-wrapper--with-image:focus .card-content::before, .card-wrapper--with-image:focus-within .card-content::before, .card-wrapper--with-image:visited .card-content::before{
        height:var(--spacing-08);
        margin-top:calc(-1 * var(--spacing-08));
        transform:translateY(calc(var(--spacing-02) * -1));
        z-index:5;
      }

@media (prefers-reduced-motion: no-preference){

.card-wrapper--with-image .card-content{
      transition:all var(--duration-promptly) ease-in-out
  }
    }

@media (prefers-reduced-motion: no-preference){

.card-wrapper--with-image .card-content .eyebrow,
    .card-wrapper--with-image .card-content a > *,
    .card-wrapper--with-image .card-content ::slotted(*){
        transition:all var(--duration-promptly) ease-in-out
    }
      }

.card-wrapper--with-image .card-content::before{
      background-color:var(--color-neutral-white);
      content:'';
      position:absolute;
      height:var(--spacing-06);
      margin-top:calc(-1 * var(--spacing-06));
      left:0;
      right:0;
    }

@media (prefers-reduced-motion: no-preference){

.card-wrapper--with-image .card-content::before{
        transition:all var(--duration-promptly) ease-in-out
    }
      }

.card-wrapper--with-image .card-image{
    border-top-left-radius:var(--border-radius--inner);
    border-top-right-radius:var(--border-radius--inner);
  }

.card-wrapper--with-image::before{
    content:'';
    position:absolute;
    top:calc(-1 * var(--border-width));
    bottom:calc(-1 * var(--border-width));
    right:calc(-1 * var(--border-width));
    left:calc(-1 * var(--border-width));
    pointer-events:none;
    z-index:6;
    background-color:transparent;
    border-color:var(--sic-card--default--border-color);
    border-color:var(
      --sic-card--border-color,
      var(--sic-card--default--border-color)
    );
    border-width:var(--border-width);
    border-style:solid;
    border-radius:var(--sic-card--default--border-radius);
    border-radius:var(
      --sic-card--border-radius,
      var(--sic-card--default--border-radius)
    );
  }

@media (prefers-reduced-motion: no-preference){

.card-wrapper--with-image::before{
      transition:all var(--duration-promptly) ease-in-out
  }
    }

.card-wrapper--with-image:focus-within::before{
    border-width:var(--border-width--focus);
    top:calc(-1 * (var(--border-width--focus) - 2px));
    bottom:calc(-1 * (var(--border-width--focus) - 2px));
    right:calc(-1 * (var(--border-width--focus) - 2px));
    left:calc(-1 * (var(--border-width--focus) - 2px));
  }

.card-wrapper--with-image.image-empty .card-content{
    background-color:transparent;
  }

.card-wrapper--with-image.image-empty .card-content::before{
      background-color:transparent;
    }

.card-wrapper--no-media,
.card-wrapper--with-icon{
  background:transparent;
  border:none;
  margin-top:calc(var(--anim-movement-amount));
  height:calc(100% - var(--anim-movement-amount));
  position:relative;
  z-index:0;
}

.card-wrapper--no-media:hover::before, .card-wrapper--no-media:focus::before, .card-wrapper--no-media:focus-within::before, .card-wrapper--with-icon:hover::before, .card-wrapper--with-icon:focus::before, .card-wrapper--with-icon:focus-within::before{
      top:calc(-1 * var(--anim-movement-amount));
    }

.card-wrapper--no-media:hover .card-content .eyebrow,
      .card-wrapper--no-media:hover .card-content a > *,
      .card-wrapper--no-media:hover .card-content ::slotted(*),
      .card-wrapper--no-media:focus .card-content .eyebrow,
      .card-wrapper--no-media:focus .card-content a > *,
      .card-wrapper--no-media:focus .card-content ::slotted(*),
      .card-wrapper--no-media:focus-within .card-content .eyebrow,
      .card-wrapper--no-media:focus-within .card-content a > *,
      .card-wrapper--no-media:focus-within .card-content ::slotted(*),
      .card-wrapper--with-icon:hover .card-content .eyebrow,
      .card-wrapper--with-icon:hover .card-content a > *,
      .card-wrapper--with-icon:hover .card-content ::slotted(*),
      .card-wrapper--with-icon:focus .card-content .eyebrow,
      .card-wrapper--with-icon:focus .card-content a > *,
      .card-wrapper--with-icon:focus .card-content ::slotted(*),
      .card-wrapper--with-icon:focus-within .card-content .eyebrow,
      .card-wrapper--with-icon:focus-within .card-content a > *,
      .card-wrapper--with-icon:focus-within .card-content ::slotted(*){
        transform:translateY(calc(var(--spacing-02) * -1));
      }

.card-wrapper--no-media:hover .card-content::before, .card-wrapper--no-media:focus .card-content::before, .card-wrapper--no-media:focus-within .card-content::before, .card-wrapper--with-icon:hover .card-content::before, .card-wrapper--with-icon:focus .card-content::before, .card-wrapper--with-icon:focus-within .card-content::before{
        height:var(--spacing-08);
        margin-top:calc(-1 * var(--spacing-08));
        transform:translateY(calc(var(--spacing-02) * -1));
        z-index:5;
      }

.card-wrapper--no-media:hover .card-icon, .card-wrapper--no-media:focus .card-icon, .card-wrapper--no-media:focus-within .card-icon, .card-wrapper--with-icon:hover .card-icon, .card-wrapper--with-icon:focus .card-icon, .card-wrapper--with-icon:focus-within .card-icon{
      transform:translateY(calc(var(--anim-movement-amount) * -2 / 3));
    }

.card-wrapper--no-media:active,
  .card-wrapper--no-media:focus-within,
  .card-wrapper--no-media:focus,
  .card-wrapper--with-icon:active,
  .card-wrapper--with-icon:focus-within,
  .card-wrapper--with-icon:focus{
    border:none;
  }

.card-wrapper--no-media:active::before, .card-wrapper--no-media:focus-within::before, .card-wrapper--no-media:focus::before, .card-wrapper--with-icon:active::before, .card-wrapper--with-icon:focus-within::before, .card-wrapper--with-icon:focus::before{
      border-width:var(--border-width--focus);
      bottom:calc(-1 * (var(--border-width--focus) - 2px));
      right:calc(-1 * (var(--border-width--focus) - 2px));
      left:calc(-1 * (var(--border-width--focus) - 2px));
    }

.card-wrapper--no-media::before, .card-wrapper--with-icon::before{
    content:'';
    position:absolute;
    top:calc(-1 * var(--border-width));
    bottom:calc(-1 * var(--border-width));
    right:calc(-1 * var(--border-width));
    left:calc(-1 * var(--border-width));
    z-index:-1;
    background-color:var(--color-neutral-white);
    border-color:var(--sic-card--default--border-color);
    border-color:var(
      --sic-card--border-color,
      var(--sic-card--default--border-color)
    );
    border-width:var(--border-width);
    border-style:solid;
    border-radius:var(--sic-card--default--border-radius);
    border-radius:var(
      --sic-card--border-radius,
      var(--sic-card--default--border-radius)
    );
  }

@media (prefers-reduced-motion: no-preference){

.card-wrapper--no-media::before, .card-wrapper--with-icon::before{
      transition:all var(--duration-promptly) ease-in-out
  }
    }

@media (prefers-reduced-motion: no-preference){

.card-wrapper--no-media .card-icon, .card-wrapper--with-icon .card-icon{
      transition:all var(--duration-promptly) ease-in-out
  }
    }

.card-wrapper--no-media .card-content, .card-wrapper--with-icon .card-content{
    background-color:transparent;
  }

@media (prefers-reduced-motion: no-preference){

.card-wrapper--no-media .card-content .eyebrow,
    .card-wrapper--no-media .card-content a > *,
    .card-wrapper--no-media .card-content ::slotted(*),
    .card-wrapper--with-icon .card-content .eyebrow,
    .card-wrapper--with-icon .card-content a > *,
    .card-wrapper--with-icon .card-content ::slotted(*){
        transition:all var(--duration-promptly) ease-in-out
    }
      }

:host([no-link]) .link-indicator{
    display:none;
  }

:host([no-link]) .heading{
    font-weight:bold;
  }

:host([no-link]) .card-wrapper{
    cursor:auto;
    pointer-events:none;
  }

:host([no-link]) .card-wrapper:hover::before, :host([no-link]) .card-wrapper:focus::before, :host([no-link]) .card-wrapper:focus-within::before, :host([no-link]) .card-wrapper:visited::before{
      top:0;
      border-width:2px;
    }

:host([no-link]) .card-wrapper:hover .card-media,
    :host([no-link]) .card-wrapper:hover .card-image,
    :host([no-link]) .card-wrapper:focus .card-media,
    :host([no-link]) .card-wrapper:focus .card-image,
    :host([no-link]) .card-wrapper:focus-within .card-media,
    :host([no-link]) .card-wrapper:focus-within .card-image,
    :host([no-link]) .card-wrapper:visited .card-media,
    :host([no-link]) .card-wrapper:visited .card-image{
      transform:none;
    }

:host([no-link]) .card-wrapper:hover .card-media > div,
      :host([no-link]) .card-wrapper:hover .card-media > picture,
      :host([no-link]) .card-wrapper:hover .card-image > div,
      :host([no-link]) .card-wrapper:hover .card-image > picture,
      :host([no-link]) .card-wrapper:focus .card-media > div,
      :host([no-link]) .card-wrapper:focus .card-media > picture,
      :host([no-link]) .card-wrapper:focus .card-image > div,
      :host([no-link]) .card-wrapper:focus .card-image > picture,
      :host([no-link]) .card-wrapper:focus-within .card-media > div,
      :host([no-link]) .card-wrapper:focus-within .card-media > picture,
      :host([no-link]) .card-wrapper:focus-within .card-image > div,
      :host([no-link]) .card-wrapper:focus-within .card-image > picture,
      :host([no-link]) .card-wrapper:visited .card-media > div,
      :host([no-link]) .card-wrapper:visited .card-media > picture,
      :host([no-link]) .card-wrapper:visited .card-image > div,
      :host([no-link]) .card-wrapper:visited .card-image > picture{
        transform:none;
      }

:host([no-link]) .card-wrapper:hover .card-content .eyebrow,
      :host([no-link]) .card-wrapper:hover .card-content a > *,
      :host([no-link]) .card-wrapper:hover .card-content ::slotted(*),
      :host([no-link]) .card-wrapper:focus .card-content .eyebrow,
      :host([no-link]) .card-wrapper:focus .card-content a > *,
      :host([no-link]) .card-wrapper:focus .card-content ::slotted(*),
      :host([no-link]) .card-wrapper:focus-within .card-content .eyebrow,
      :host([no-link]) .card-wrapper:focus-within .card-content a > *,
      :host([no-link]) .card-wrapper:focus-within .card-content ::slotted(*),
      :host([no-link]) .card-wrapper:visited .card-content .eyebrow,
      :host([no-link]) .card-wrapper:visited .card-content a > *,
      :host([no-link]) .card-wrapper:visited .card-content ::slotted(*){
        transform:none;
      }

:host([no-link]) .card-wrapper:hover .card-content::before, :host([no-link]) .card-wrapper:focus .card-content::before, :host([no-link]) .card-wrapper:focus-within .card-content::before, :host([no-link]) .card-wrapper:visited .card-content::before{
        display:none;
      }

@container (min-width: 680px){
  .card-wrapper--with-image{
    display:flex;
  }

    .card-wrapper--with-image .card-image,
    .card-wrapper--with-image .card-content{
      flex:0 0 50%;
    }
    .card-wrapper--with-image .card-image{
      border-top-right-radius:0;
    }
      .card-wrapper--with-image .card-image div:not(.contextual){
        height:100%;
      }
      .card-wrapper--with-image .card-image picture{
        display:flex;
        height:100%;
      }

        .card-wrapper--with-image .card-image picture img{
          height:100%;
          width:100%;
          object-fit:cover;
        }
    .card-wrapper--with-image .card-content{
      padding:var(--spacing-12);
    }

      .card-wrapper--with-image .card-content ::slotted(*){
        transition:none;
      }
      .card-wrapper--with-image .card-content::before{
        display:none;
      }
        .card-wrapper--with-image:hover .card-content .eyebrow,
        .card-wrapper--with-image:hover .card-content a > *,
        .card-wrapper--with-image:hover .card-content ::slotted(*),
        .card-wrapper--with-image:focus .card-content .eyebrow,
        .card-wrapper--with-image:focus .card-content a > *,
        .card-wrapper--with-image:focus .card-content ::slotted(*),
        .card-wrapper--with-image:focus-within .card-content .eyebrow,
        .card-wrapper--with-image:focus-within .card-content a > *,
        .card-wrapper--with-image:focus-within .card-content ::slotted(*),
        .card-wrapper--with-image:visited .card-content .eyebrow,
        .card-wrapper--with-image:visited .card-content a > *,
        .card-wrapper--with-image:visited .card-content ::slotted(*){
          transform:translateY(0);
        }

    .card-wrapper--with-image:focus-within{
      --border-width--focus:4px;
    }
      .card-wrapper--with-image:focus-within::before{
        border-width:var(--border-width);
        top:calc(-1 * var(--border-width));
        bottom:calc(-1 * var(--border-width));
        right:calc(-1 * var(--border-width));
        left:calc(-1 * var(--border-width));

        outline-width:var(--border-width--focus);
        outline-style:solid;
        outline-color:var(--sic-card--default--border-color);
        outline-color:var(
          --sic-card--border-color,
          var(--sic-card--default--border-color)
        );
        outline-offset:2px;
      }
    .card-wrapper--no-media .link-indicator{
      bottom:calc(-1 * var(--border-width) + 1px);
      right:calc(-1 * var(--border-width) + 1px);
    }
  .card-heading{
    font-size:var(--headline-04-font-size);
    line-height:var(--headline-04-line-height);
  }
  .description{
    --sic-text-color:var(--color-neutral-default);
    font-size:var(--body-01-font-size);
    line-height:var(--body-01-line-height);
  }
}
`;